// extracted by mini-css-extract-plugin
module.exports = {"grid":"feature_grid__3zKF_","info":"feature_info__zb0fk","title":"feature_title__Xqrxf","text":"feature_text__h8RKD","button":"feature_button__awenC","code":"feature_code__3gbSx"};